<template>
    <div class="renderQueueMAnager">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Render Manager</span>
        </heading-wrap>
        <stats
           v-if="renderStats"
          :html="renderStats.html"
          :psd="renderStats.psd"
          :htmlVideo="renderStats.html_video"
          :afterEffects="renderStats.after_effects"
          :htmlCapacity="renderCapacity.html"
          :psdCapacity="renderCapacity.psd"
          :htmlVideoCapacity="renderCapacity.html_video"
          :afterEffectsCapacity="renderCapacity.after_effects"
        ></stats>
        <spinner v-if="loading" />
        <hr/>
        <admin-batch
                v-for="(batch, index) in renderBatches"
                :index="index"
                :name="batch.project"
                :batchId="batch.id"
                :batchName="batch.name"
                :key="batch.id"
                :queues="batch.queues"
                :user="batch.created_by"
                :client="batch.client"
                :campaign="batch.campaign"
                :creative="batch.creative"
                :time_started="batch.time_started"
                :renders_requested="batch.renders_requested"
                :parentMoveUp="moveUp"
                :parentMoveDown="moveDown"
                :parentRemove="remove"
        />
      </div>
    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import AdminBatch from '@/components/AdminBatch/admin-batch'
import Spinner from '@/components/SpinnerIcon/spinner'
import Stats from '@/components/RenderManager/stats'
import {notificationMixin} from '@/mixins/notificationMixin'
import {renderMixin} from '@/mixins/renderMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'RenderManager',
  mixins: [notificationMixin, renderMixin, modalMixin],
  components: {
    HeadingWrap,
    AdminBatch,
    Spinner,
    Stats
  },
  data: () => ({
    queueJobs: [],
    timeoutId: null
  }),
  mounted () {
    this.updateRenderBatch(true)
  },
  methods: {
    move (array, name, priority, delta) {
      const index = this.getPositionFromString(array, name)
      const newIndex = index + delta
      // console.log('newIndex ' + newIndex)
      // console.log('priority ' + priority)
      // console.log('delta ' + delta)
      let fromReplace = array[newIndex]
      let toReplace = array[index]
      let payload = {
        id: toReplace.id,
        priority: fromReplace.priority
      }
      this.startLoading()
      this.updateRenderQueue(payload).then(() => {
        payload = {
          id: fromReplace.id,
          priority: toReplace.priority
        }
        this.updateRenderQueue(payload).then(() => {
          this.updateRenderBatch().then(() => {
            this.finishLoading()
          })
        })
      })
      // if (newIndex < 0 || newIndex === array.length) return // already at the top or bottom.
      // const indexes = [index, newIndex].sort() // sort the indexes
      // array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]) // replace from lowest index, two elements, reverting the order
      // array = array.map((item, index) => (item.position = index)) // update item positions
      // this.queueJobs = array
    },
    moveBatch (array, element, position, toMove) {
      const batchIdToReplace = this.getBatchIdFromPosition(array, position)
      const batchIdWithReplace = this.getBatchIdFromPosition(array, position + toMove)
      let payload = {
        id: batchIdToReplace,
        replace_batch: batchIdWithReplace
        // toMove: toMove
      }
      this.startLoading()
      this.updateRenderQueueBatchWise(payload).then(() => {
        this.finishLoading()
      })
    },
    moveUp (array, element, position, type) {
      if (type === 'batch') {
        // move complete batch
        this.moveBatch(array, element, position, -1)
      } else {
        // move queues within batch
        this.move(array, element, position, -1)
      }
    },
    moveDown (array, element, position, type) {
      if (type === 'batch') {
        // move complete batch
        this.moveBatch(array, element, position, 1)
      } else {
        // move queues within batch
        this.move(array, element, position, 1)
      }
    },
    getPositionFromString (array, text) {
      return array.map((e) => e.name).indexOf(text)
    },
    getBatchIdFromPosition (array, position) {
      return array[position].id
    },
    remove (array, id, name, type) {
      let functionToCall
      if (type === 'queue') {
        functionToCall = this.deleteRenderQueue.bind(this)
      } else if (type === 'batch') {
        functionToCall = this.deleteRenderBatch.bind(this)
      }
      this.startLoading()
      functionToCall(id).then(() => {
        this.updateRenderBatch(false).then(() => {
          this.addNotification('info', `${name} has been removed.`)
          this.finishLoading()
        })
      })
      // this.queueJobs = array
    },
    updateRenderBatch (loading = true) {
      if (loading) this.startLoading()
      return this.getRenderBatches().then(() => {
        if (loading) this.finishLoading()
        this.timeoutId = setTimeout(() => this.updateRenderBatch(false), 3000)
      })
    },
    cancelTimeout () {
      clearTimeout(this.timeoutId)
    }
  },
  beforeDestroy () {
    this.cancelTimeout()
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/render-manager.vue